import { render, staticRenderFns } from "./chatSpin.vue?vue&type=template&id=9a110768&"
import script from "./chatSpin.vue?vue&type=script&lang=js&"
export * from "./chatSpin.vue?vue&type=script&lang=js&"
import style0 from "./chatSpin.vue?vue&type=style&index=0&id=9a110768&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports